import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Collapse } from "bootstrap";


export default class PageAwards {
    constructor(dom) {
        this.dom = dom;
        window.addEventListener("resize", () => this.resize());
    }

    async init() {
        this.handlefilter()
    }

    handlefilter() {
        const filter = this.dom.querySelector('.www-filter')
        const award_items = this.dom.querySelectorAll('.award-list .items .item')
        const myCollapse = filter.querySelector('.collapse')
        const bsCollapse = new Collapse(myCollapse, {
            toggle: false
        })
        if (filter) {
            filter.querySelectorAll('[js-filter-year]').forEach(item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()
                    const year = item.dataset.year
                    // filter.querySelector('.dropdown-item.selected').classList.remove('selected')
                    filter.querySelectorAll('[js-filter-year].selected').forEach(item => {
                        item.classList.remove('selected')
                    })
                    // item.classList.add('selected')
                    filter.querySelectorAll(`[js-filter-year][data-year="${year}"]`).forEach(item => {
                        item.classList.add('selected')
                    })
                    
                    // filter.querySelector('.selected-item').textContent = year
                    // filter.querySelector('.selected-item').textContent = year
                    filter.querySelectorAll(`.selected-item`).forEach(item => {
                        item.textContent = year
                    })

                    gsap.to(window, { duration: .5, scrollTo: { y: this.dom.querySelector('.award-list'), offsetY: 250 } });

                    award_items.forEach(award_item => {
                        if (award_item.dataset.year == year) {
                            award_item.classList.add('active')
                        } else {
                            award_item.classList.remove('active')
                        }
                    })

                    // close filter BS collapse
                    
                    if (myCollapse) {
                        bsCollapse.hide()
                    }


                })
            })
        }
    }
    resize() {
    }

    destroy() {

    }
}
